import React from 'react';
import {
  getGenreString,
  convertSecondsToMinutes,
  useOffer,
} from '../../utils/helpers';

import MediaDetails from '../MediaDetails';

import { IMedia } from '../../utils/models';
import { TAccessServiceType } from '../../@types/Access';
import AccessServiceBadge from '../AccessServiceBadge';
import { KiteIcon, KiteLink } from '@kite/react-kite';
export interface MovieDetailsProps {
  media: IMedia;
  accessServices?: TAccessServiceType[];
}

const MovieDetails = ({
  media: {
    title,
    imageUrl,
    description,
    descriptors,
    genres,
    ratings,
    duration,
    releaseYear,
    topCast,
    offer,
  },
  accessServices,
}: MovieDetailsProps) => {
  const currentOffer = useOffer(offer);

  const { startTime, endTime } = currentOffer;

  const rating =
    ratings && ratings.find((rating) => rating.agency === 'mpaa')?.rating;
  const genreString = getGenreString(genres);
  const director = topCast?.find((person) => person.role === 'DIRECTOR')?.name;

  const header = (
    <div className="header">
      {/* Genres */}
      {genreString && <span className="header__detail">{genreString}</span>}

      {/* Duration */}
      {duration && (
        <span className="header__detail">
          {convertSecondsToMinutes(duration)} Mins
        </span>
      )}

      {/* Release Year */}
      {releaseYear && <span className="header__detail">{releaseYear}</span>}

      {/* Rating */}
      {rating && <span className="header__detail">{rating}</span>}

      {/* RottenTomatoes */}
      {/* {critic_image && (
        <span className="header__detail">
          <img
            src={`${BASE_IMAGE_URI}${critic_image}&width=24`}
            alt="Rotten Tomatoes"
            className="logo"
          />
          {critic_rating}%
        </span>
      )} */}
    </div>
  );

  const footer = (
    <div className="footer">
      {/* Director */}
      {director && (
        <span className="footer__detail">
          <span className="label">Director</span>
          {director}
        </span>
      )}
      {!!accessServices?.length && (
        <span className="footer__access-cta">
          Accessible features are available for this title on{' '}
          <KiteLink
            className="screenshot-access-block__description-link"
            href="https://access-app.spectrum.net/explore"
            type="standalone"
          >
            Spectrum Access 
            <KiteIcon
              className="access-cta__link-icon"
              icon="ki-chevron-right"
              size="14px"
            />
          </KiteLink>
        </span>
      )}
    </div>
  );

  const accessServiceBadges = accessServices?.length ? (
    <div className="access-service-badges">
      {accessServices.sort().map((type: TAccessServiceType) => (
        <AccessServiceBadge
          type={type}
          key={`${title}-${type}`}
          iconOnly={false}
        />
      ))}
    </div>
  ) : null;

  return (
    <MediaDetails
      title={title}
      imageUri={`${imageUrl}?sourceType=colorHybrid&twccategory=Poster&width=257`}
      description={description}
      header={header}
      footer={footer}
      moods={descriptors?.moods}
      dates={{ startTime, endTime }}
      accessServiceBadges={accessServiceBadges}
    />
  );
};

export default MovieDetails;
